// CRÍTICO: Importar el fix del worker ANTES de importar pdfjs-dist
// El fix intercepta fetch y XHR antes de que PDF.js los use
import { WORKER_URL, CORRECT_VERSION } from './utils/pdfjsWorkerFix.js'

// SOLUCIÓN CRÍTICA: Usar wrapper que fuerza la versión correcta ANTES de importar
// Esto asegura que la versión se sobrescriba antes de que PDF.js construya la URL del worker
import pdfjsLib, { WORKER_URL as WRAPPER_WORKER_URL, CORRECT_VERSION as WRAPPER_VERSION } from './utils/pdfjsWrapper.js'

// Usar los valores del wrapper (son los mismos, pero garantizamos consistencia)
const FINAL_WORKER_URL = WRAPPER_WORKER_URL || WORKER_URL;
const FINAL_VERSION = WRAPPER_VERSION || CORRECT_VERSION;

// Exponer pdfjsLib globalmente para que el fix pueda acceder a él
if (typeof window !== 'undefined') {
  window.pdfjsLib = pdfjsLib;
  
  // Verificar que el workerSrc está configurado correctamente
  console.log('[PDF.js] 🔧 WorkerSrc después del wrapper:', pdfjsLib.GlobalWorkerOptions.workerSrc);
  console.log('[PDF.js] Versión después del wrapper:', pdfjsLib.version);
  
  // Forzar nuevamente por si acaso
  pdfjsLib.GlobalWorkerOptions.workerSrc = FINAL_WORKER_URL;
  console.log('[PDF.js] ✅ WorkerSrc forzado nuevamente a:', FINAL_WORKER_URL);
}

// SOLUCIÓN DEFINITIVA: Usar el worker desde la carpeta public
// Esto evita problemas con import.meta.url y asegura que Vite lo sirva correctamente

// CORRECT_VERSION ya está importado desde pdfjsWorkerFix.js

// CRÍTICO: Sobrescribir la propiedad version ANTES de configurar el worker
// pdfjs-dist usa internamente pdfjsLib.version para construir URLs del worker
if (typeof window !== 'undefined') {
  try {
    // Guardar la versión original para referencia
    const originalVersion = pdfjsLib.version || 'unknown'
    console.log('[PDF.js] Versión original reportada:', originalVersion)
    console.log('[PDF.js] Versión correcta esperada:', CORRECT_VERSION)
    
    // SOLUCIÓN: Verificar si la propiedad ya está definida antes de intentar redefinirla
    const descriptor = Object.getOwnPropertyDescriptor(pdfjsLib, 'version')
    if (descriptor && !descriptor.configurable) {
      // Si ya está definida y no es configurable, no intentar redefinirla
      console.log('[PDF.js] ⚠️ La propiedad version ya está definida y no es configurable, omitiendo redefinición')
    } else {
      // SOLUCIÓN ULTRA-AGRESIVA: Sobrescribir version ANTES de que PDF.js lo lea
      // Usar Object.defineProperty con configurable: true para permitir redefiniciones
      Object.defineProperty(pdfjsLib, 'version', {
        get: () => CORRECT_VERSION,
        set: () => {
          // Ignorar intentos de cambiar la versión
          console.warn('[PDF.js] ⚠️ Intento de cambiar versión bloqueado')
        },
        configurable: true, // Permitir redefiniciones si es necesario
        enumerable: true
      })
      console.log('[PDF.js] ✅ Versión sobrescrita a:', CORRECT_VERSION)
      console.log('[PDF.js] Versión actual después de sobrescribir:', pdfjsLib.version)
    }
  } catch (e) {
    console.warn('[PDF.js] No se pudo sobrescribir version:', e)
  }
}

// Configurar el worker ANTES de que cualquier código lo use
// CRÍTICO: Hacer esto inmediatamente después de importar
// FORZAR el workerSrc ANTES de que PDF.js intente usarlo
if (typeof window !== 'undefined') {
  // Establecer el workerSrc inmediatamente
  pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
  
  // Verificar que se estableció correctamente
  console.log('[PDF.js] 🔧 WorkerSrc configurado inmediatamente a:', pdfjsLib.GlobalWorkerOptions.workerSrc);
  console.log('[PDF.js] Versión de pdfjsLib:', pdfjsLib.version);
  
  // Verificar inmediatamente si cambió
  setTimeout(() => {
    const current = pdfjsLib.GlobalWorkerOptions.workerSrc;
    if (current !== WORKER_URL && (current.includes('5.4.530') || current.includes('cdnjs'))) {
      console.warn('[PDF.js] ⚠️ WorkerSrc cambió inmediatamente después de configurarlo!');
      console.warn('[PDF.js] Valor actual:', current);
      console.warn('[PDF.js] Forzando worker local...');
      pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
    }
  }, 0);
}

// Verificar que la configuración se aplicó correctamente
if (typeof window !== 'undefined') {
  // SOLUCIÓN AGRESIVA: Interceptar TODOS los intentos de cambiar workerSrc
  let workerSrcValue = WORKER_URL
  
  // Sobrescribir la propiedad workerSrc para bloquear cambios no deseados
  // HACERLO ANTES de que PDF.js lo use
  try {
    Object.defineProperty(pdfjsLib.GlobalWorkerOptions, 'workerSrc', {
      get: () => {
        // Si el valor actual contiene 5.4.530 o cualquier versión incorrecta, forzar el worker local
        if (workerSrcValue && (workerSrcValue.includes('5.4.530') || workerSrcValue.includes('cdnjs.cloudflare.com/ajax/libs/pdf.js/5'))) {
          console.warn('[PDF.js] ⚠️ Detectada versión incorrecta, forzando worker local')
          workerSrcValue = WORKER_URL
        }
        return workerSrcValue
      },
      set: (value) => {
        // Bloquear CUALQUIER intento de usar versión incorrecta del CDN
        if (value && (value.includes('5.4.530') || value.includes('cdnjs.cloudflare.com/ajax/libs/pdf.js/5') || (value.includes('cdnjs') && !value.includes('3.11.174')))) {
          console.warn('[PDF.js] ⚠️ BLOQUEADO cambio a versión incorrecta:', value)
          console.warn('[PDF.js] ✅ Usando worker local en su lugar')
          workerSrcValue = WORKER_URL
          return
        }
        // Permitir otros cambios válidos (pero registrar para debug)
        if (value !== WORKER_URL) {
          console.log('[PDF.js] WorkerSrc cambiado a:', value)
        }
        workerSrcValue = value || WORKER_URL
      },
      configurable: true,
      enumerable: true
    })
    
    // Establecer el valor inicial usando el setter
    pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL
    console.log('[PDF.js] ✅ Worker configurado (protegido):', pdfjsLib.GlobalWorkerOptions.workerSrc)
    console.log('[PDF.js] Versión reportada por pdfjsLib:', pdfjsLib.version)
  } catch (e) {
    console.warn('[PDF.js] No se pudo proteger workerSrc, usando asignación directa:', e)
    pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL
    console.log('[PDF.js] ✅ Worker configurado (directo):', pdfjsLib.GlobalWorkerOptions.workerSrc)
  }
  
  // SOLUCIÓN ULTRA-AGRESIVA: Interceptar fetch/import dinámicos que intenten cargar el worker incorrecto
  if (typeof window.fetch !== 'undefined') {
    const originalFetch = window.fetch.bind(window)
    window.fetch = function(...args) {
      const url = args[0]
      if (typeof url === 'string' && (url.includes('pdf.js/5.4.530') || (url.includes('pdf.js/5') && !url.includes('3.11.174')))) {
        console.warn('[PDF.js] ⚠️ BLOQUEADO fetch a worker incorrecto:', url)
        console.warn('[PDF.js] ✅ Redirigiendo a worker local')
        // Redirigir al worker local
        return originalFetch(WORKER_URL, ...args.slice(1))
      }
      return originalFetch(...args)
    }
  }
  
  // SOLUCIÓN CRÍTICA: Interceptar import() dinámicos usando múltiples estrategias
  try {
    // Estrategia 1: Interceptar errores de import dinámico
    const errorHandler = (event) => {
      const errorMsg = event.message || event.error?.message || '';
      if (errorMsg.includes('pdf.js/5.4.530') || 
          errorMsg.includes('Failed to fetch dynamically imported module') ||
          (errorMsg.includes('pdf.js/5') && !errorMsg.includes('3.11.174'))) {
        console.warn('[PDF.js] ⚠️ Error de import dinámico detectado:', errorMsg);
        // No prevenir el error, pero forzar el worker correcto
        setTimeout(() => {
          pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
          console.log('[PDF.js] ✅ Worker forzado después de error de import');
        }, 0);
      }
    };
    window.addEventListener('error', errorHandler, true);
    window.addEventListener('unhandledrejection', (event) => {
      const reason = event.reason?.message || event.reason?.toString() || '';
      if (reason.includes('pdf.js/5.4.530') || reason.includes('Failed to fetch dynamically imported module')) {
        console.warn('[PDF.js] ⚠️ Rechazo no manejado de import dinámico:', reason);
        event.preventDefault();
        // Forzar el worker correcto
        pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
      }
    }, true);
    
    // Estrategia 2: Interceptar todas las peticiones de red usando un Service Worker proxy
    // (Esto se hace en index.html, pero verificamos aquí también)
    
    // Estrategia 3: Verificación continua del workerSrc
    const monitorWorker = setInterval(() => {
      const current = pdfjsLib.GlobalWorkerOptions.workerSrc;
      if (current && (current.includes('5.4.530') || (current.includes('cdnjs') && !current.includes('3.11.174')))) {
        console.warn('[PDF.js] ⚠️ Worker cambió a versión incorrecta durante monitoreo, corrigiendo...');
        pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
      }
    }, 100);
    
    // Limpiar el monitor después de 10 segundos (suficiente tiempo para que PDF.js se inicialice)
    setTimeout(() => clearInterval(monitorWorker), 10000);
    
  } catch (e) {
    console.warn('[PDF.js] No se pudo interceptar errores de import:', e);
  }
  
  // Verificación periódica para asegurar que el worker no cambie
  const checkWorker = () => {
    const current = pdfjsLib.GlobalWorkerOptions.workerSrc
    if (current && (current.includes('5.4.530') || (current.includes('cdnjs') && !current.includes('3.11.174')))) {
      console.warn('[PDF.js] ⚠️ Worker cambió a versión incorrecta, corrigiendo...')
      pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL
    }
  }
  
  // Verificar inmediatamente y después de delays
  setTimeout(checkWorker, 10)
  setTimeout(checkWorker, 100)
  setTimeout(checkWorker, 500)
  setTimeout(checkWorker, 1000)
  setTimeout(checkWorker, 2000)
}

// CRÍTICO: Importar bloqueador de navegación PRIMERO, antes de cualquier otra cosa
import './utils/modalNavigationBlocker.js'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Filtrar errores de extensiones del navegador que no afectan la aplicación
const originalError = window.console.error
const originalWarn = window.console.warn

// Lista de patrones de errores de extensiones del navegador a filtrar
const extensionErrorPatterns = [
  'fido2-page-script-registration',
  'Duplicate script ID',
  'Frame with ID',
  'background.js',
  'Extension context invalidated',
  'Cannot find menu item with id',
  'PhishingDetectionService',
  'runtime.lastError',
  'The page keeping the extension port',
  'back/forward cache',
  'message channel is closed',
  'autofill',
  'copy-password',
  'copy-username',
  'copy-totp',
  'autofill-card',
  'menu item with id root',
  'Retrieving application id'
]

// Lista de errores HTTP esperados que no deben mostrarse como errores
const expectedHttpErrors = [
  '/api/auth/me',  // 401 es esperado cuando no hay token o expiró
]

const isExtensionError = (message) => {
  const errorMessage = typeof message === 'string' ? message : String(message)
  return extensionErrorPatterns.some(pattern => errorMessage.includes(pattern))
}

window.console.error = (...args) => {
  const errorMessage = args.join(' ')
  
  // Filtrar errores conocidos de extensiones del navegador
  if (isExtensionError(errorMessage)) {
    // Silenciar estos errores de extensiones
    return
  }
  
  // Filtrar errores HTTP esperados (401 en /api/auth/me es normal cuando no hay token)
  if (expectedHttpErrors.some(pattern => errorMessage.includes(pattern) && errorMessage.includes('401'))) {
    // Silenciar estos errores HTTP esperados
    return
  }
  
  // Mostrar otros errores normalmente
  originalError.apply(console, args)
}

window.console.warn = (...args) => {
  const warningMessage = args.join(' ')
  
  // Filtrar advertencias de extensiones del navegador
  if (isExtensionError(warningMessage)) {
    // Silenciar estas advertencias de extensiones
    return
  }
  
  // Mostrar otras advertencias normalmente
  originalWarn.apply(console, args)
}

// También filtrar errores no capturados de promesas relacionados con extensiones
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || event.reason?.toString() || ''
  
  if (isExtensionError(errorMessage)) {
    // Prevenir que estos errores aparezcan en la consola
    event.preventDefault()
    return
  }
})

// Filtrar errores de runtime.lastError de extensiones de forma segura
try {
  if (typeof window !== 'undefined' && window.chrome?.runtime) {
    const descriptor = Object.getOwnPropertyDescriptor(window.chrome.runtime, 'lastError')
    if (descriptor) {
      const originalGetter = descriptor.get
      Object.defineProperty(window.chrome.runtime, 'lastError', {
        get: function() {
          try {
            const error = originalGetter ? originalGetter.call(this) : undefined
            if (error && error.message && isExtensionError(error.message)) {
              return undefined
            }
            return error
          } catch (e) {
            return undefined
          }
        },
        configurable: true,
        enumerable: true
      })
    }
  }
} catch (e) {
  // Ignorar errores al intentar modificar chrome.runtime.lastError
  // Esto es normal si chrome.runtime no está disponible
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Ocultar overlay inicial cuando React ya montó; las rutas lo volverán a mostrar si están cargando
setTimeout(function() {
  if (window.__hideLoadingOverlay) window.__hideLoadingOverlay()
}, 0)

